import { createApp } from 'vue';

import Filters from '../components/general/filters.vue';
import BrokerageContainer from '../components/brokerageListings/brokerage.vue';
import getWindowSize from '../helpers/getWindowSize';

const brokerageElement = document.getElementById('properties-container');

if (brokerageElement) {
    const logoutUrl = brokerageElement.getAttribute('data-logout-url') || null;
    const brokerageApp = createApp({
        components: { BrokerageContainer },
        template: `
            <BrokerageContainer
                :window-size="windowSize"
                :logout-url="logoutUrl"
            />
        `,
        data() {
            return {
                windowSize: getWindowSize(),
                logoutUrl,
            };
        },
        mounted() {
            window.addEventListener('resize', this.updateWindowSize);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.updateWindowSize);
        },
        methods: {
            updateWindowSize() {
                this.windowSize = getWindowSize();
            },
        },
    });

    brokerageApp.config.compilerOptions.whitespace = 'preserve';
    brokerageApp.component('filters', Filters);
    brokerageApp.mount(brokerageElement);
}
